export default __webpack_public_path__ + "static/media/send_message_light.eec10154.svg";